import React, { useState, useCallback } from "react";
import axios from "axios";
import HttpAction from "modules/utils/HttpAction";
import ErroCode from "modules/utils/ErrorCode";
import { URL } from "modules/utils/Common";
const ImformationContext = React.createContext({
  state: { imformationList: {}, imformation: {} },
  actions: {
    getImformation: () => {},
    getImformationList: () => {},
  },
});

const ImformationProvider = ({ children }) => {
  const [imformation, setImformation] = useState({});
  const [imformationList, setImformationList] = useState([]);
  
  const getImformationList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/admin/disclosure/list", 
      method: "get",
      params: {
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        disclosureCategory: pageInfo && pageInfo.disclosureCategory,
        disclosureTitle: pageInfo && pageInfo.disclosureTitle,
      }
    }).then((res) => {
      if (res.code === 200) {
        setImformationList(res.data);
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const getImformation = useCallback((disclosureId) => {
    HttpAction({
      url:"api/admin/disclosure", 
      method: "get",
      params: {
        disclosureId: disclosureId
      }
    }).then((res) => {
      if (res.code === 200) {
        setImformation(res.data); 
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const createImformation = useCallback(async (imformationData,setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
      .post(`api/admin/disclosure/save`, imformationData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Access-Control-Allow-Origin": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          Language: process.env.REACT_APP_LANGUAGE,

        },
      })
      .then((res) => {
        if (res.data.code === 200) {
          setState({
            type: "SAVE",
            state: true,
          });
          getImformationList({})
        } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
      });
  }, []);

  const updateImformation = useCallback(async (imformationData, setState) => {
    axios.defaults.baseURL = process.env.REACT_APP_API_URL
    await axios
    .post(`api/admin/disclosure/modify`, imformationData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Access-Control-Allow-Origin": "multipart/form-data",
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
        Language: process.env.REACT_APP_LANGUAGE,
      },
    })
    .then((res) => {
      if (res.data.code === 200) {
        setState({
          type: "SAVE",
          state: true,
        });
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
    
  }, []);
 
  const deleteImformation = useCallback((disclosureId, history) => {
    HttpAction({
      url: "api/admin/disclosure",
      method: "delete",
      params: {
        disclosureId: disclosureId
      }
    }).then((res) => {
      if (res.code === 200) {
      history.push(`${URL.ADMIN_BASE_URL}/promotion/imformation`)
      } else {
        ErroCode[res.code] && (window.location.href = `${process.env.REACT_APP_LANGUAGE === "en"?"/en":"/kr"}/500`);
      }
    });
  }, []);

  const value = {
    state: { imformation, imformationList },
    actions: { getImformationList, getImformation, createImformation, updateImformation, deleteImformation },
  };

  return (
    <ImformationContext.Provider value={value}>
      {children}
    </ImformationContext.Provider>
  );
};

const { Consumer: ImformationConsumer } = ImformationContext;

export { ImformationProvider, ImformationConsumer, ImformationContext };

export default ImformationContext;
